module.exports = __webpack_public_path__ + "assets/Angle3Detailed.9b96f52b3eb7541328ecd15c8933f4c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle3Detailed.png
// module id = 460
// module chunks = 0